import Feedbacks from '@/pages/feedback/feedbacks'

export default [
  {
    path: '/feedbacks',
    name: 'Feedbacks',
    component: Feedbacks,
    meta: { name: '意见反馈' }
  }
]



// WEBPACK FOOTER //
// ./src/router/feedback/feedbacks.js